// extracted by mini-css-extract-plugin
module.exports = {"alert":"alert___2u34s","message":"message___3I7qf","report":"report___PZlKp"};